export const REQ_VEHICLESMIN_SUCCESS = "REQ_VEHICLESMIN_SUCCESS"